import "./Style/WebinarForm.scss";
import { useState } from "react";
import axios from "../../../index";
import { useNavigate, useParams } from "react-router-dom";
import { useRazorpay } from "react-razorpay";
import handlePayment from "../../Payment/RazorPayFunction";
import Alert from "./Alert";

export function WebinarForm({
  title,
  subtitle,
  startAt,
  isFree,
  bannerImage,
  mentorName,
  coutDown,
}) {
  const param = useParams();
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success"); // "success" | "error"
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [webinarUser, setWebinarUser] = useState({
    username: "",
    email: "",
    mobileNumber: "",
    webinar: param.webinarId,
  });
  const [fieldValidator, setFieldValidator] = useState({
    username: true,
    email: true,
    mobileNumber: true,
  });
  const Razorpay = useRazorpay();
  const navigate = useNavigate();
  function onChangeHandler(event) {
    const { name, value } = event.target;
    setWebinarUser({ ...webinarUser, [name]: value });
  }
  const emailPattan = /^\w+([\.-]?\w)*@\w+([\.-]?\w*)*(\.[a-z\D]{2,3})$/gi;
  const numberPattan = /^\d{10}$/;
  const stringPattan = /^([a-zA-Z\s]{3})\s?([a-zA-Z\s]*)$/;
  function validator() {
    let username = true;
    let email = true;
    let mobileNumber = true;
    if (!stringPattan.test(webinarUser.username)) {
      username = false;
    }
    if (!emailPattan.test(webinarUser.email)) {
      email = false;
    }
    if (!numberPattan.test(webinarUser.mobileNumber)) {
      mobileNumber = false;
    }

    setFieldValidator({
      username: username,
      email: email,
      mobileNumber: mobileNumber,
    });
    return username && email && mobileNumber;
  }

  function registerWebinar() {
    setIsLoading(true);
    axios
      .post("/webinar/user/add", webinarUser)
      .then((res) => {
        setIsLoading(false);
        console.log(res.data);
        setWebinarUser({
          username: "",
          email: "",
          mobileNumber: "",
          webinar: param.webinarId,
        });

        // Show success alert
        setShowAlert(true);
        setAlertType("success");
        setAlertMessage("🎉 Registration successful! Redirecting to WhatsApp group...");

        // ✅ Redirect to WhatsApp after a delay (e.g., 1 seconds)
        setTimeout(() => {
          window.open("https://chat.whatsapp.com/DmvoHEc3vrbHfVnoEe2nX1", "_blank");
        }, 1000);
      })
      .catch((error) => {
        setIsLoading(false);
        setShowAlert(true);
        setAlertType("error");
        setAlertMessage(error.response?.data?.message || "Something went wrong. Try again.");
      });
  }

  function registerWebinarWithPayment() {
    let userInfo = {
      firstName: webinarUser.username,
      email: webinarUser.email,
      mobileNumber: webinarUser.mobileNumber,
    };
    if (validator()) {
      if (isFree === 0) {
        registerWebinar();
      } else {
        handlePayment(Razorpay, isFree, {
          successCallback: registerWebinar,
          courseInfo: { courseName: title },
          userInfo: userInfo,
        });
      }
    } else {
      console.log("invalid form field");
    }
  }
  return (
    <section className="webinarForm">
      {showAlert && (
        <Alert
          type={alertType}
          message={alertMessage}
          onClose={() => setShowAlert(false)}
        />
      )}
      <p className="title">{title}</p>
      <p className="subTitle">{subtitle}</p>
      <section className="row">
        <section className="left">
          <img src={bannerImage} alt="banner image"></img>
          <p>With {mentorName}</p>
        </section>
        <section className="right">
          <section className="timer">
            <div className="time">
              <span>
                {coutDown.days > 9 ? coutDown.days : `0${coutDown.days}`}
              </span>
              <span>:</span>
              <span>
                {coutDown.hours > 9 ? coutDown.hours : `0${coutDown.hours}`}
              </span>

              <span>:</span>
              <span>
                {coutDown.minutes > 9
                  ? coutDown.minutes
                  : `0${coutDown.minutes}`}
              </span>

              <span>:</span>
              <span>
                {coutDown.seconds > 9
                  ? coutDown.seconds
                  : `0${coutDown.seconds}`}
              </span>
            </div>

            <div className="day">
              <span>DAY</span>
              <span></span>
              <span>HRS</span>
              <span></span>
              <span>MIN</span>
              <span></span>
              <span>SEC</span>
            </div>
          </section>

          <p>Webinar Start In</p>
          <input
            type="text"
            placeholder="Name"
            name="username"
            value={webinarUser.username}
            onChange={onChangeHandler}
          />
          {!fieldValidator.username && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "left", margin: "0px 35px" }}>invalid username</p>
          )}
          <input
            type="number"
            placeholder="Phone Number"
            name="mobileNumber"
            value={webinarUser.mobileNumber}
            onChange={onChangeHandler}
          />
          {!fieldValidator.mobileNumber && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "left", margin: "0px 35px" }}>invalid mobileNumber</p>
          )}
          <input
            type="text"
            placeholder="Email"
            name="email"
            value={webinarUser.email}
            onChange={onChangeHandler}
          />
          {!fieldValidator.email && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "left", margin: "0px 35px" }}>invalid email</p>
          )}
          <div className="btn" onClick={registerWebinarWithPayment} disabled={isLoading}>
            <span>{isLoading ? "⏳ Please wait, registering..." : "📝 Register"}</span>
          </div>
          <p>
            {/* // TODO: terms and condition */}
            By joining, you agree to receive webinar-related updates via email/SMS. No spam, we promise!
          </p>
        </section>
      </section>
      <div className="circleLg"></div>
      <div className="circle"></div>
      <div className="square"></div>
      <div className="triangle"></div>
    </section>
  );
}
